import { Shape, ExtrudeGeometry, Matrix4 } from 'three';

// Local metres: X across road, Y up, +Z INTO tunnel. The mouth is at Z=0.
export const PORTAL_WIDTH = 7;
export const PORTAL_MIN_ZOOM = 16.5;
const SPRING = 2.8, RISE = 2.3;

// Hvor tykk silhuetten er, i meter. Bare nok til at den har en kant.
const PORTAL_DEPTH = .4;

function arch(shape, radius, rise, reverse = false) {
  for (let i = 0; i <= 20; i++) {
    const t = Math.PI * (reverse ? i / 20 : 1 - i / 20);
    shape.lineTo(Math.cos(t) * radius, SPRING + Math.sin(t) * rise);
  }
}




export function createPortalGeometries() {
  // Én flate: rektangel med halvbue på toppen - tunnelmunningen i silhuett.
  //
  // Tidligere var dette fire deler (fasade, hvelv, vinger, refleksbrikker),
  // og det ble for detaljert: portalen konkurrerte med ruta om
  // oppmerksomheten i stedet for bare å markere hvor tunnelen er. Nå er den
  // én mørk form, og selve "her er det tunnel"-informasjonen bæres av den
  // stiplede ruta, som kan slås av og på.
  //
  // Tynt ekstrudert (ikke helt flat) så den ikke forsvinner sett fra siden.
  const shape = new Shape(), r = PORTAL_WIDTH / 2;
  shape.moveTo(-r, 0);
  arch(shape, r, RISE);
  shape.lineTo(r, 0);
  shape.closePath();
  const marker = new ExtrudeGeometry(shape, {
    steps: 1, bevelEnabled: false, curveSegments: 16, depth: PORTAL_DEPTH,
  });
  return { marker };
}

export function uniquePortals(data) {
  const result = [];
  for (const f of data.features) {
    const { coordinates } = f.geometry, p = f.properties;
    const duplicate = result.find(other => {
      const [lng, lat] = other.coordinates;
      const metres = Math.hypot((lng - coordinates[0]) * Math.cos(lat * Math.PI / 180), lat - coordinates[1]) * 111195;
      const angle = Math.abs(((other.bearing - p.bearing + 540) % 360) - 180);
      return other.kind === p.kind && metres < 3 && angle < 20;
    });
    const width = ['motorway', 'trunk'].includes(p.road_class) ? 8.5 : 7;
    // Short underpasses must not get two vaults overlapping each other.
    const depth = Math.min(2.5, (p.tunnel_length_m ?? 20) * .3);
    if (duplicate) {
      duplicate.modes.push(p.mode);
      duplicate.width = Math.max(duplicate.width, width);
      duplicate.depth = Math.min(duplicate.depth, depth);
    } else result.push({ coordinates, bearing: p.bearing, kind: p.kind, modes: [p.mode], width, depth });
  }
  return result;
}

// Compass bearing is measured into the tunnel at BOTH ends. In Mercator,
// X=east, Y=south, Z=up. This avoids mirrored or sideways portals.
export function portalMatrix(bearing, scale = 1, translation = [0, 0, 0]) {
  const a = bearing * Math.PI / 180, c = Math.cos(a) * scale, s = Math.sin(a) * scale;
  return new Matrix4().set(
    c, 0, s, translation[0],
    s, 0, -c, translation[1],
    0, scale, 0, translation[2],
    0, 0, 0, 1,
  );
}
